export const DiscordLink = "https://discord.gg/tbPkWQZ7Fk";